import type { AdminEmailMailboxListProps } from "../../models/admin-email.models";
import AdminEmailUnreadCount from "./AdminEmailUnreadCount";
import { twMerge } from "tailwind-merge";

// Offer only the mailbox entries supplied by the server's committed whitelist.
// There is deliberately no address field or action for adding a mailbox from the browser.
const AdminEmailMailboxList = ({ mailboxes, selectedId, countsUnavailable, onSelect }: AdminEmailMailboxListProps) => (
  <nav aria-label="Email inboxes" data-test="admin-email-mailboxes" className="space-y-2">
    {mailboxes.map((mailbox) => (
      <button
        key={mailbox.id}
        type="button"
        data-test={`admin-email-mailbox-${mailbox.id}`}
        aria-pressed={selectedId === mailbox.id}
        className={twMerge(
          "w-full rounded border border-gray-200 p-3 text-left transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-green dark:border-gray-700",
          selectedId === mailbox.id
            ? "border-green bg-[#E9F4F3] dark:bg-gray-700"
            : "hover:bg-gray-50 dark:hover:bg-gray-700",
        )}
        onClick={() => onSelect(mailbox.id)}
      >
        <span className="flex items-center justify-between gap-2">
          <span className="text-sm font-semibold">{mailbox.label}</span>
          <AdminEmailUnreadCount
            count={mailbox.unreadCount}
            unavailable={countsUnavailable || Boolean(mailbox.error)}
          />
        </span>
        <span className="mt-2 block break-all text-xs opacity-60">{mailbox.address}</span>
        {mailbox.error && <span className="mt-2 block text-xs text-[#BF0002]">{mailbox.error}</span>}
      </button>
    ))}
  </nav>
);

export default AdminEmailMailboxList;
